import "@/index.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Products from "./components/Products";
import WhyAlumak from "./components/WhyAlumak";
import Projects from "./components/Projects";
import Process from "./components/Process";
import Showroom from "./components/Showroom";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";

function App() {
  return (
    <div className="App min-h-screen bg-white text-brand-charcoal">
      <Header />
      <main>
        <Hero />
        <Products />
        <Projects />
        <WhyAlumak />
        <Process />
        <Showroom />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}

export default App;
